import { useState } from "react";

const CumulusLocationTracking = () => {
  const [scriptLoaded, setScriptLoaded] = useState(false);

  const loadCumulusLocationScript = () => {
    if (scriptLoaded) return;

    // Load First Tracking Pixel (Cumulus CL Pixel)
    const ordnumber = Math.random() * 10000000000000;
    const sscUrl = `https://trkn.us/pixel/conv/ppt=23632;g=airport_home_appliance_store_locations;gid=57612;ord=${ordnumber};v=120`;

    const img = document.createElement("img");
    img.src = sscUrl;
    img.alt = "";
    img.width = 1;
    img.height = 1;
    document.body.appendChild(img);

    // Load Second Tracking Script (SFI On-Off Pixel)
    const script = document.createElement("script");
    script.src =
      "https://tag.simpli.fi/sifitag/fc347661-c598-4212-8111-f2b96060c7a4";
    script.async = true;
    document.body.appendChild(script);

    setScriptLoaded(true);
  };

  return { loadCumulusLocationScript };
};

export default CumulusLocationTracking;
